// extracted by mini-css-extract-plugin
module.exports = {"tabs":"e_Z9","title":"e__9","list":"e_09","listActive":"e_19","leftList":"e_29","rightList":"e_39","grid":"e_49"};